import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./screens/authentication/SignIn";
import Dashboard from "./screens/Dashboard";
import { MainLayout } from "./components";
import PrivateRoute from "./components/PrivateRoute";
import SignUp from "./screens/authentication/SignUp";
import PaymentsPay from "./screens/payments/Pay";
import PaymentsComplete from "./screens/payments/Complete";
import ForgotPassword from "./screens/authentication/ForgotPassowrd";
import Payments from "./screens/admin/Payments";
import PaymentRequests from "./screens/admin/PaymentRequests";
import PublicRoute from "./components/PublicRoute";

const AppRoutes: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/signup"
          element={
            <PublicRoute>
              <SignUp />
            </PublicRoute>
          }
        />
        <Route
          path="/forgotpassword"
          element={
            <PublicRoute>
              <ForgotPassword />
            </PublicRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <MainLayout>
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            </MainLayout>
          }
        />
        <Route path="/payments/pay" element={<PaymentsPay />} />
        <Route path="/payments/done" element={<PaymentsComplete />} />
        <Route
          path="/payments/requests"
          element={
            <MainLayout>
              <PrivateRoute>
                <PaymentRequests />{" "}
              </PrivateRoute>
            </MainLayout>
          }
        />
        <Route
          path="/payments/list"
          element={
            <MainLayout>
              <PrivateRoute>
                <Payments />{" "}
              </PrivateRoute>
            </MainLayout>
          }
        />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
